import React from 'react';
import { Hero } from './components/sections/Hero';
import { TheProblem } from './components/sections/TheProblem';
import { Audience } from './components/sections/Audience';
import { TheSystem } from './components/sections/TheSystem';
import { Results } from './components/sections/Results';
import { Offer } from './components/sections/Offer';
import { Testimonials } from './components/sections/Testimonials';
import { FAQ } from './components/sections/FAQ';
import { Purchase } from './components/sections/Purchase';
import { SocialProofPopup } from './components/ui/SocialProofPopup';
export function App() {
  return <div className="min-h-screen bg-white text-gray-900 font-sans selection:bg-gold selection:text-white" data-id="element-0">
      <Hero data-id="element-1" />
      <TheProblem data-id="element-2" />
      <Audience data-id="element-3" />
      <TheSystem data-id="element-4" />
      <Results data-id="element-5" />
      <Offer data-id="element-6" />
      <Purchase data-id="element-7" />
      <Testimonials data-id="element-8" />
      <FAQ data-id="element-9" />
      <SocialProofPopup data-id="element-10" />
    </div>;
}